import React from "react"
import Img from "gatsby-image"

const Header = ({ image }) => {
  return <Img fluid={image?.fluid} style={{ maxHeight: `50vh` }}></Img>
}

export default Header
